// @flow
import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { CloudUpload, Done } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { ColorSchema, WhiteText, GreyText } from "../../global/types/scss";

type UploadFieldStatesType = {
  dragged: boolean
};

const styles = theme => ({
  fileUploadButton: {
    backgroundColor: WhiteText,
    color: GreyText,
    fontSize: "15px",
    textTransform: "capitalize",
    border: "3px outset " + ColorSchema("secondary"),
    padding: "22px",
    borderRadius: "3px",
    boxShadow: "0 0 0 1px " + ColorSchema("primary"),
    textAlign: "center",
    width: "100%",
    "& > SPAN":{
      display: "block",
    },
    "&:hover, &.hover, &:active, &.active": {
      cursor: "pointer",
      backgroundColor: ColorSchema("third"),
      color: WhiteText,
    },
  },
  fileUploadText: {
    fontSize: "24px",
    lineHeight: "30px",
  },
});

const inital = {
  dragged: false
};

class UploadField extends Component<*, UploadFieldStatesType> {
  constructor(props) {
    super(props);
    this.state = inital;
  }

  preventDefault = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
  };

  inputDragLeave = (e: Event) => {
    this.preventDefault(e);
    e.target.classList.toggle("hover");
    this.setState({ dragged: false });
  };

  inputDragEnter = (e: Event) => {
    this.preventDefault(e);
    e.target.classList.toggle("hover");

    this.setState({ dragged: true });
  };

  inputDrop = (e: Event, callback: Function) => {
    this.preventDefault(e);
    callback(e);
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <div>
        <label
          htmlFor="raised-button-file"
          className="file-upload-label"
          draggable={true}
          onDragEnter={this.inputDragEnter}
          onDragOver={this.preventDefault}
          onDrop={e => this.inputDrop(e, this.props.uploadFileActions)}
          onDragLeave={this.inputDragLeave}
        >
          <Button variant="raised" component="span" color="primary" className={classes.fileUploadButton}>
            <span className={classes.fileUploadText}>
              Drag and Drop<br />
              Selfie here.<br />
              Or just Click it.<br />
            </span>
            {this.state.dragged ? <Done className="large-icon" /> : <CloudUpload className="large-icon" />}
          </Button>
        </label>
        <input
          accept="image/*"
          onChange={this.props.uploadFileActions}
          id="raised-button-file"
          type="file"
          className="file-upload-input"
        />
      </div>
    );
  }
}


export default withStyles(styles)(UploadField);


// WEBPACK FOOTER //
// ./src/conference/component/UploadField.js